module.exports = __webpack_public_path__ + "static/favicon-281cd737b29ab2bde76101a4e5f6b18e.ico";